import { apiRoutes } from "../../config"
import { api } from "../../utils/lib/api"



export const getDataApiDebug = async (params)=>{
    try {
        //Obtenemos el id de la cuenta de Vtex
        const url = `${apiRoutes.apiDebug.getId}/`
        console.log(url, 'url')
        console.log(params, 'paramsparams')
        return (await api.get(url, 
            {
                params:{
                    page: params.page,
                    limit: params.limit,
                    productId: params.productId,
                    sku: params.sku,
                    enterpriseId: params.enterpriseId,
            }}
    ))
    } catch (error) {
        console.log(error)
        throw new Error(error)

    }
}
 


